function cookiepolicy() {
    $('#cookie-policy').hide()
    document.cookie = '_cookiepolicy=true; path=/; max-age=2592000;'
    return false
}

export function setupCookiePolicy(cookiePolicyUrl) {
    var text =
        'Page uses cookie files with respect of ' +
        ' <a class="cookie-url" target="_blank" href="' +
        cookiePolicyUrl +
        '">Cookie Policy</a>. ' +
        'We and our partners use technologies, such as cookies, and collect browsing data to give you the best online experience and to personalize the content and advertising shown to you.'
    var link =
        '<a href="#" class="btn btn-primary cookie-url-accept">' +
        'OK' +
        '</a>'
    var cookiePolicyText =
        '<div class="cookie-policy" id="cookie-policy"><div class="container"><div class="row"><div class="col-left">' +
        text +
        '</div><div class="col-right">' +
        link +
        '</div></div></div></div>'

    if (document.cookie.indexOf('_cookiepolicy=true') === -1) {
        $('body')
            .append(cookiePolicyText)
        // .css('margin-bottom', '90px')
        $('.cookie-url-accept').on('click', function (e) {
            e.preventDefault()
            cookiepolicy()
        })
    }
}